import NewProduct from '../components/NewProduct';

export default function AdminPage() {
  return (
    <div>
      <NewProduct />
    </div>
  );
}
